import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Tabs,
  Tab
} from "@mui/material";
import Header from "@components/Header/Header";
import bgImage from "../../assets/images/BG.svg";

const Signup = () => {
  const [activeTab, setActiveTab] = useState("Individual");

  return (
    <Box className="login-root" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="page-content">
        {/* <Header /> */}

        {/* Main Box */}
        <Box display="flex" justifyContent="center" px={4}>
          <Paper elevation={3} className="login-box pb-4">

            <>
              <Typography
                component="label"
                htmlFor="aadhaar"
                className="aadhaar-label"
              >
                Enter Number
              </Typography>

              <TextField
                fullWidth
                id="aadhaar"
                placeholder="Enter your Mobile Number"
                className="aadhaar-input"
              />

              <Box className="btn-wrapper">
                <Button className="btnContinue">Continue</Button>
              </Box>

              <Typography className="otp-note">
                We will send an OTP to the phone number registered with this
                Aadhaar number
              </Typography>
            </>
            <br />
          </Paper>
        </Box>
      </div>
      <br />
    </Box>
  );
};

export default Signup;
